import Icon from '../components/Icon.vue'

Icon.register({"columns":{"width":1664,"height":1792,"paths":[{"d":"M160 1536h608v-1152h-640v1120q0 13 9.5 22.5t22.5 9.5zM1536 1504v-1120h-640v1152h608q13 0 22.5-9.5t9.5-22.5zM1664 288v1216q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1344q66 0 113 47t47 113z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/columns.js
// module id = 197
// module chunks = 0